import request from '@/utils/request'


// 查询评论列表
export function listComment(query) {
  return request({
    url: '/tree/comment/list',
    method: 'get',
    params: query
  })
}

export function commentPage(query) {
  return request({
    url: '/tree/comment/commentPage',
    method: 'get',
    params: query
  })
}

export function replyPage(query) {
  return request({
    url: '/tree/comment/replyPage',
    method: 'get',
    params: query
  })
}

// 查询评论分页
export function pageComment(query) {
  return request({
    url: '/tree/comment/page',
    method: 'get',
    params: query
  })
}

// 查询评论详细
export function getComment(data) {
  return request({
    url: '/tree/comment/detail',
    method: 'get',
    params: data
  })
}

// 新增评论
export function addComment(data) {
  return request({
    url: '/tree/comment/add',
    method: 'post',
    data: data
  })
}

// 修改评论
export function updateComment(data) {
  return request({
    url: '/tree/comment/edit',
    method: 'post',
    data: data
  })
}

// 删除评论
export function delComment(data) {
  return request({
    url: '/tree/comment/delete',
    method: 'post',
    data: data
  })
}
